/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./videoFacet.defs.js";
export { main as default } from "./videoFacet.defs.js";
